import { useHead, useThemeState, computed, useThemeListState } from "#imports";

/**
 * Set the theme to the given key, or a default if no key is provided.
 * @param key The key to set.
 */
export function setTheme ( key?: string ) {
  const themeState = useThemeState();
  const themesState = useThemeListState();

  if ( !key ) {
    // no key given, try and use default, else no theme
    const themeDetails = themesState.value?.find( t => t.isDefault );
    themeState.value = themeDetails?.key || null;
  } else {
    // key given, find and use it or throw error
    const themeDetails = themesState.value?.find( t => t.key === key );

    if ( !themeDetails ) {
      throw new Error( "Unable to find theme with key: " + key );
    }

    themeState.value = themeDetails.key;
  }

  const details = computed( () => themeState.value
    ? themesState.value?.find( x => x.key === themeState.value )
    : null );

  const cssHref = computed( () => details.value
    ? `/assets/theme.${details.value.key}.${details.value.hash}.css`
    : "" );

  if ( !cssHref.value ) {
    return;
  }

  useHead( {
    link: [
      {
        rel: "preload",
        as: "style",
        href: cssHref.value,
      },
      {
        rel: "stylesheet",
        href: cssHref.value,
      },
    ],
  } );
}
